module.exports = __webpack_public_path__ + "img/41400.e8b46a5a.jpg";